import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography,
} from '@mui/material';
import * as React from 'react';
import ControlledDialog from '../../components/dialog/controlled-dialog';
import ControlledInput from '../../components/input/controlled-input';
import Textarea from '../../components/textarea/textarea';
import MuiPhone from '../../components/input/mui-phone-input';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPurchaseDialog,
  purchaseDialogToggled,
} from '../../store/car-slice';

export default function Purchase() {
  const [loading, setLoading] = React.useState(false);
  const purchaseDialog = useSelector(getPurchaseDialog);
  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    fullname: '',
    email: '',
    phone: '',
    message: '',
    isFinance: false,
  });

  const onSubmit = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      dispatch(purchaseDialogToggled());
    }, 1000);
    console.log('submit');
  };

  const handleClose = () => {
    dispatch(purchaseDialogToggled());
  };

  const renderContent = (
    <Box display={'flex'} flexDirection={'column'} gap={1}>
      <ControlledInput
        label="Full name"
        onChange={(e: { target: { value: any } }) =>
          setState({ ...state, fullname: e.target.value })
        }
        value={state.fullname}
      />
      <ControlledInput
        label="Email address"
        onChange={(e: { target: { value: any } }) =>
          setState({ ...state, email: e.target.value })
        }
        value={state.email}
      />
      <MuiPhone
        id="phoneNumber"
        label={'Phone'}
        onChange={(e: string) => setState({ ...state, phone: e })}
        placeholder="Enter your phone number"
        style={{ backgroundColor: 'white' }}
        value={state.phone}
      />
      <Textarea
        label="Message"
        onChange={(e: { target: { value: any } }) =>
          setState({ ...state, message: e.target.value })
        }
        rows={4}
        value={state.message}
      />
      <Box display={'flex'} justifyContent={'space-between'}>
        <Box>
          <Typography>Do you need financing?</Typography>
        </Box>
        <Box display={'flex'} flexDirection={'row'} mr={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.isFinance} // Use state to control the checkbox
                defaultChecked
                onChange={() => setState({ ...state, isFinance: true })} // Add onChange handler
              />
            }
            label="Yes"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={!state.isFinance} // Use state to control the checkbox
                onChange={() => setState({ ...state, isFinance: false })} // Add onChange handler
              />
            }
            label="No"
          />
        </Box>
      </Box>
      {loading && (
        <Alert severity="success">Your information successFully added.</Alert>
      )}
    </Box>
  );

  const renderActions = (
    <Button
      color="info"
      disabled={loading}
      fullWidth
      onClick={onSubmit}
      variant="contained"
    >
      {loading ? <CircularProgress size={16} /> : 'Submit'}
    </Button>
  );

  return (
    <ControlledDialog
      handleClose={handleClose}
      maxWidth="sm"
      onSubmit={onSubmit}
      open={purchaseDialog}
      renderActions={renderActions}
      renderContent={renderContent}
      renderTitle="Information Purchase Online"
    />
  );
}
